import { Decoration_Type } from 'ricos-types';

const DEFAULT_PALETTE = ["#FFFFFF", "#D5D4D4", "#ABCAFF", "#0141AA", "#012055", "#000000"];
const TEXT_COLOR_MODAL_ID = `${Decoration_Type.COLOR}.foreground.picker`;
const TEXT_HIGHLIGHT_MODAL_ID = `${Decoration_Type.COLOR}.background.picker`;
const COLOR_PICKER_MODAL_ID = "color-picker-modal-id";

export { COLOR_PICKER_MODAL_ID, DEFAULT_PALETTE, TEXT_COLOR_MODAL_ID, TEXT_HIGHLIGHT_MODAL_ID };
//# sourceMappingURL=constants.js.map
